import { EmptyState } from "@/components/feedback/EmptyState";
import type { TableEmptyStateProps } from "./DataTable.types";

// `title` and `description` are required — the no-data view is always a two-line
// message. DataTable supplies defaults for both.
export function TableEmptyState({ title, description, action, colSpan = 1, className }: TableEmptyStateProps) {
  return (
    <tr>
      <td colSpan={colSpan}>
        <EmptyState variant="table" title={title} description={description} primaryAction={action} className={className} />
      </td>
    </tr>
  );
}
